import React, { useState } from "react";
import {Link} from 'react-router-dom';

const roleOrder = ["All", "Owner", "Admin", "Worker", "Member", "Supporter", "Pledged Without Role"];
const roleIcons = {
  All: <i className="fa-solid fa-users" style={{ color: "#7aa5f0" }} />,
  Owner: <i className="fa-solid fa-crown" style={{ color: "#FFD43B" }} />,
  Admin: <i className="fa-solid fa-user-shield" style={{ color: "#44657e" }} />,
  Worker: <i className="fa-solid fa-user-tie" style={{ color: "#63E6BE" }} />,
  Member: <i className="fa-solid fa-user" style={{ color: "#B197FC" }} />,
  Supporter: <i className="fa-regular fa-user" style={{ color: "#bd98aa" }} />,
  "Pledged Without Role": <i className="fa-solid fa-coins" style={{ color: "#dfcac8" }} />,
};

const GuildMembers = ({ users }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [roleFilter, setRoleFilter] = useState("All");

  // Filter out Watchers and apply filters
  const filteredUsers = users
    .filter((user) => user.role !== "Watcher")
    .filter(
      (user) =>
        roleFilter === "All" ||
        user.role === roleFilter ||
        (roleFilter === "Pledged Without Role" && user.stakedShards > 0 && user.role === "Supporter")
    )
    .filter((user) => user.player.username.toLowerCase().includes(searchTerm.toLowerCase()));

  // Sort by role priority then username
  const sortedUsers = [...filteredUsers].sort((a, b) => {
    const roleA = a.role || (a.stakedShards > 0 ? "Pledged Without Role" : "");
    const roleB = b.role || (b.stakedShards > 0 ? "Pledged Without Role" : "");

    if (roleOrder.indexOf(roleA) !== roleOrder.indexOf(roleB)) {
      return roleOrder.indexOf(roleA) - roleOrder.indexOf(roleB);
    }
    return a.player.username.localeCompare(b.player.username);
  });

  return (
    <div className="space-y-4">
      {/* Filters */}
      <div className="flex flex-col gap-2 p-2 filters-panel rounded-lg w-full text-[var(--text3-color)]">
          <label className="text-xs font-semibold">Search Members</label>
          <input
            type="text"
            placeholder="Search by name..."
            className="w-full p-2 select-forms"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

      {/* Role Summary */}
      <div className="flex flex-wrap gap-2 mb-4">
        {roleOrder.map((role) => {
          // Calculate counts differently for special cases
          let count;
          if (role === "All") {
            count = users.filter((u) => u.role !== "Watcher").length;
          } else if (role === "Pledged Without Role") {
            count = users.filter((u) => u.stakedShards > 0 && u.role === "Supporter").length;
          } else if (role === "Pledged") {
            count = users.filter((u) => u.stakedShards > 0).length;
          } else {
            count = users.filter((u) => u.role === role).length;
          }

          // Only show button if there are members in this role
          return count > 0 ? (
            <button
              key={role}
              onClick={() => setRoleFilter(role)}
              className={`px-3 py-1 rounded-full text-sm flex items-center gap-1 ${
                roleFilter === role ? "bg-indigo-100 text-indigo-800 border border-indigo-300" : "bg-gray-100 text-gray-800"
              }`}
            >
              {roleIcons[role]}
              {role}: {count}
            </button>
          ) : null;
        })}
      </div>

      {/* Members List */}
      <div className="space-y-2 home-section">
        {sortedUsers.map((user) => {
          const role = user.role || (user.stakedShards > 0 ? "Pledged Without Role" : "Member");
          return (
            <div key={user._id} className="p-2 border rounded-lg bg-[var(--panel-bg-color)] hover:bg-[var(--entity-hover-bg-color)] flex items-center justify-between">
              <div className="flex items-center gap-1 text-sm">
                <div className="text-lg">{roleIcons[role]}</div>
                <div>
                  <Link to={user.player._id} target="_blank" rel="noreferrer"><div className="font-medium text-[var(--text3-color)]">{user.player.username}</div></Link>
                  <div className="text-sm text-[var(--text-color)]">
                    {role} {user.stakedShards > 0 && `• ${user.stakedShards} shards pledged`}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {sortedUsers.length === 0 && <div className="text-center py-8 text-gray-500">No members found matching your filters</div>}
    </div>
  );
};

export default GuildMembers;
